import { render, staticRenderFns } from "./index.vue?vue&type=template&id=54273c60&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=54273c60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54273c60",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ShimmerEffect: require('/workspace/components/ShimmerEffect.vue').default,PremiumCoupon: require('/workspace/components/PremiumCoupon.vue').default,PlaceCardv2Restaurant: require('/workspace/components/PlaceCardv2Restaurant.vue').default,RestaurantCard: require('/workspace/components/RestaurantCard.vue').default})
